import { PaginationMetadata } from "@/types"

export function hasMorePages(paginationMetadata?: PaginationMetadata) {
    return !!paginationMetadata && (paginationMetadata.currentPage < paginationMetadata.totalPages)
}
